/*
 * API
 * needLoading: { Boolean } 是否需要请求加载时的 loading 组件
 * opacity: { Boolean } 是否隐藏 loading 背景蒙层 
 * delay: { Number } 是否延迟销毁 loading 组件
 */
import service from '@/utils/request'

const info = params => {
  return service.get('/api/info', { params: params, needLoading: true, opacity: false })
}

export default {
  info,
}



// WEBPACK FOOTER //
// ./src/api/index.js